import pmdCookieCheckout from '../PmdCartCookie/pmdCookieCheckout';
var pmeCookieCheckout = function pmeCookieCheckout(page) {
  var config = {
    cookieShowcaseName: 'pme_showcase_name',
    partnerId: 67633,
    prefix: 'parceiro'
  };
  pmdCookieCheckout(page, config);
};
export default pmeCookieCheckout;